var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Field',{on:{"save":_vm.save},scopedSlots:_vm._u([{key:"view",fn:function(){return [_vm._v(" "+_vm._s(_vm.name)+" ")]},proxy:true},{key:"edit",fn:function(){return [_c('v-text-field',{model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }